import React from "react";
import { Avatar, Menu, MenuItem, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../hooks/useAuth";
// import { useLogoutUser } from "../../hooks/authHooks";
import { useLogoutUser } from "../../hooks/dataHooks";
import { decodeJWT } from "../../utils/commonUtils";

const UserMenu = () => {
    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = React.useState(null);

    const { authData } = useAuth();

    const { mutate: logoutUser } = useLogoutUser();

    let userDetails = null;

    // Decode the access token to extract user information
    if (authData?.accessToken) {
        try {
            userDetails = decodeJWT(authData.accessToken);
        } catch (error) {
            console.error("Error decoding access token:", error);
        }
    }

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget); // Open the menu at the clicked element
    };

    const handleMenuClose = () => {
        setAnchorEl(null); // Close the menu
    };

    const handleMenuProfile = () => {
        handleMenuClose();
        // Navigate to profile (if needed)
        navigate("/profile");
    };

    // const handleMenuSettings = () => {
    //     handleMenuClose();
    //     // Navigate to settings (if needed)
    //     navigate("/settings");
    // };

    const handleLogout = () => {
        logoutUser({ refreshToken: authData.refreshToken, accessToken: authData.accessToken });
        handleMenuClose();
        navigate("/");
    };

    return (
        <>
            {userDetails?.name && (
                <IconButton edge="end" color="inherit" onClick={handleMenuOpen}
                    sx={{
                        padding: 0,
                        margin: 0,
                    }}
                >
                    <Avatar
                        sx={{
                            backgroundColor: "primary.dark",
                            cursor: "pointer",
                            width: 30, // Adjust the width
                            height: 30, // Adjust the height
                            fontSize: 22, // Adjust the font size for the text inside the Avatar
                            fontWeight: "semibold",
                            color: 'primary.contrastText',
                            marginLeft: 1,
                        }}
                        aria-controls="user-menu"
                        aria-haspopup="true"                        // edge="end"
                    >
                        {userDetails.name.substring(0, 1).toUpperCase()}
                    </Avatar>
                </IconButton>
            )}

            {/* Menu Dropdown */}
            <Menu
                id="user-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose} // Close the menu when clicked outside
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
        </>
    );
};

export default UserMenu;
